import { escapeHtml } from '../utils/dom.js';

export function renderWizardShell({ title, subtitle, steps, currentStep, backHref, bodyHtml }) {
  const stepItems = steps
    .map(
      (label, i) => `
        <li class="wizard-steps__item${i + 1 === currentStep ? ' wizard-steps__item--active' : ''}${i + 1 < currentStep ? ' wizard-steps__item--done' : ''}">
          <span class="wizard-steps__num">${i + 1}</span>
          <span class="wizard-steps__label">${escapeHtml(label)}</span>
        </li>
      `,
    )
    .join('');

  return `
    <div class="app-shell app-shell--wizard">
      <header class="app-header app-header--wizard">
        <a class="app-header__back" href="${escapeHtml(backHref)}" aria-label="Indietro">
          <svg class="app-header__back-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </a>
        <div class="app-header__center">
          <h1 class="app-header__title">${escapeHtml(title)}</h1>
          ${subtitle ? `<p class="app-header__subtitle">${escapeHtml(subtitle)}</p>` : ''}
        </div>
      </header>
      <ol class="wizard-steps" aria-label="Passaggi">${stepItems}</ol>
      <main class="app-main app-main--wizard">${bodyHtml}</main>
    </div>
  `;
}

export const PLAN_WIZARD_STEPS = ['Info', 'Giorni', 'Tappe', 'Lista', 'Riepilogo'];
export const INSTANCE_WIZARD_STEPS = ['Rotta', 'Gruppo', 'Alloggi', 'Via!'];
